"use client";

import { IBlog, ISingleBlogResponse } from "@/types/blog.type";
import Footer from "@components/footer/footer";
import MoveToTop from "@components/move-to-top/move-to-top";

import { useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";
import SubHeader from "@components/sub-header/sub-header";
import Tags from "@components/tags/tags";
import ContentSingle from "@components/content-single/content-single";
import NewsRecentPosts from "../news-recent-posts/news-recent-posts";
import SubCategories from "@components/sub-categories/sub-categories";
import NewsPagination from "../news-pagination/news-pagination";
import { getSingleNews } from "@/services/news.service";
import { INews, ISingleNewsResponse } from "@/types/news.type";

interface INewsDetailMainPage {
  locale: string;
  slug: string;
}

export default function NewsDetailMainPage({ locale, slug }: INewsDetailMainPage) {
  const searchParams = useSearchParams();
  const search = slug;
  const [blog, setBlog] = useState<INews | null>(null);
  useEffect(() => {
    getSingleNews(locale, search || "")
      .then((res: ISingleNewsResponse) => {
        setBlog(res.data);
      })
      .catch(console.log);
  }, [locale, search]);
  return (
    <>
      <NewsPagination locale={locale} />

      {blog && (
        <ContentSingle locale={locale} news={blog} blog={null} />
      )}
      {blog && <Tags locale={locale} tags={blog.attributes.news_tags.data} />}

      {blog && blog.attributes?.news_category?.data && (
        <NewsRecentPosts
          locale={locale}
          blogCategory={blog.attributes.news_category.data.attributes.name}
        />
      )}
      
      {/* {blog && (
        <ContentSingle locale={locale} news={blog} blog={null} />
      )}
      {blog && <Tags locale={locale} tags={blog.attributes.news_tags.data} />}
      <NewsLetter locale={locale} />
      {blog && blog.attributes.news_category.data && (
        <NewsRecentPosts
          locale={locale}
          blogCategory={blog.attributes.news_category.data.attributes.name}
        />
      )} */}
    </>
  );
}
